module.exports = __webpack_public_path__ + "img/logo-dyg.6b7cd07b.png";